function normalizeActionId(actionId) {
  if (!actionId || typeof actionId !== 'string') return '';
  return actionId.replace(/_/g, '.').toLowerCase();
}

function hasPrefix(actionId, prefixes) {
  const normalized = normalizeActionId(actionId);
  return prefixes.some((prefix) => normalized.startsWith(prefix));
}

export function isTaskRelatedAction(actionId) {
  return hasPrefix(actionId, ['task.', 'todo.']);
}

export function isProjectRelatedAction(actionId) {
  return hasPrefix(actionId, ['project.']);
}

export function isDiscussionRelatedAction(actionId) {
  return hasPrefix(actionId, ['discussion.']);
}

export function isMilestoneRelatedAction(actionId) {
  return hasPrefix(actionId, ['milestone.']);
}

export function isTeamRelatedAction(actionId) {
  return hasPrefix(actionId, ['team.']);
}

export function isCalendarRelatedAction(actionId) {
  return hasPrefix(actionId, ['calendar.', 'googlecalendar.']);
}

export function isTaskOrProjectRelatedAction(actionId) {
  return isTaskRelatedAction(actionId) || isProjectRelatedAction(actionId);
}

export function isProjectPageRelatedAction(actionId) {
  return hasPrefix(actionId, ['project.', 'task.', 'todo.', 'discussion.', 'milestone.', 'team.']);
}

function pickFirst(...values) {
  for (const value of values) {
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return null;
}

function extractTask(result) {
  const data = result?.data;
  if (!data || typeof data !== 'object') return null;
  return pickFirst(data.task, data.updatedTask, data.newTask, data);
}

function extractProject(result) {
  const data = result?.data;
  if (!data || typeof data !== 'object') return null;
  return pickFirst(data.project, data.updatedProject, data);
}

function extractProjectId(result) {
  const task = extractTask(result);
  const project = extractProject(result);
  const data = result?.data || {};

  return pickFirst(
    data.projectId,
    project?._id,
    project?.id,
    task?.projectId,
    task?.project?._id,
    task?.project?.id,
    task?.project
  );
}

export function emitUiRefreshFromAiAction(actionId, result) {
  if (!actionId || typeof window === 'undefined') return;

  const normalized = normalizeActionId(actionId);
  const task = extractTask(result);
  const project = extractProject(result);
  const projectId = extractProjectId(result);

  if (isTaskRelatedAction(normalized)) {
    const detail = {
      action: 'updated',
      type: 'task_updated',
      task: task || {},
      projectId: projectId || null,
    };
    window.dispatchEvent(new CustomEvent('taskUpdated', { detail }));
    window.dispatchEvent(new CustomEvent('task_status_changed', { detail }));
  }

  if (isProjectRelatedAction(normalized)) {
    const detail = {
      action: 'updated',
      project: project || {},
      projectId: projectId || project?._id || project?.id || null,
    };
    window.dispatchEvent(new CustomEvent('projectUpdated', { detail }));
  }

  if (isDiscussionRelatedAction(normalized)) {
    window.dispatchEvent(
      new CustomEvent('newDiscussionMessage', {
        detail: { action: 'updated', projectId: projectId || null, payload: result?.data || null },
      })
    );
  }
}
